<div class="lng-tab-header">
  <span *ngFor="let tab of items" (click)="selectTab(tab)" [class.active]="tab.active" class="tab-header">
    {{tab.language.getLabel()}}
  </span>
</div>
<div class="tabs"   *ngIf="forms" [formGroup]="forms">
<div *ngFor="let tab of items" [class.active]="tab.active" class="tabcontent">
  <textarea formControlName="{{tab.language.getLabel()}}"    name="text"></textarea>
</div>
</div>